import { PracticeTypeData } from "@/utils/practiceTypeData";
import * as LucideIcons from "lucide-react";

interface PracticeRisksProps {
  practiceType: PracticeTypeData;
}

const PracticeRisks = ({ practiceType }: PracticeRisksProps) => {
  return (
    <section className="py-12 sm:py-16 md:py-20">
      <div className="container mx-auto max-w-6xl px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            Spezifische Cyber-Risiken für {practiceType.name}
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-3xl mx-auto">
            {practiceType.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {practiceType.specificRisks.map((risk, index) => {
            const IconComponent = LucideIcons[risk.icon as keyof typeof LucideIcons] as any;
            
            return (
              <div
                key={index}
                className="p-6 rounded-lg bg-card border border-border hover:border-accent/50 transition-all duration-300"
              >
                <div className="flex items-start gap-4 mb-4">
                  {IconComponent && (
                    <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-accent/10 rounded-lg flex items-center justify-center">
                      <IconComponent className="w-5 h-5 sm:w-6 sm:h-6 text-accent" />
                    </div>
                  )}
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold mb-2">{risk.title}</h3>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground mb-3">
                  {risk.description}
                </p>
                <div className="pt-3 border-t border-border">
                  <p className="text-xs font-semibold text-accent">
                    {risk.statistic}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PracticeRisks;
